import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-8 md:py-10">
      <div className="flex items-center justify-center gap-2 md:gap-3 flex-wrap">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className="flex items-center gap-2 px-4 py-2 rounded-full bg-background-100 hover:bg-primary-500/20 text-foreground-700 hover:text-primary-400 border border-background-300/40 hover:border-primary-500/40 transition-all duration-200 text-sm font-medium whitespace-nowrap"
          >
            <i className={`${cat.icon} text-base`} />
            {cat.name}
          </Link>
        ))}
      </div>
    </section>
  );
}